export default __webpack_public_path__ + "static/media/ETH.6154dd62.svg";